export default __webpack_public_path__ + "static/media/F3.a18d2817.gif";